//Api for admin signup
import apiCall from "../apiService";
import { AUTH_ROUTES } from "../../utils/constants/apiRoute";

/**
 * Signup a user with provided credentials and returns the response data.
 *
 * Sends a POST request to the backend API to authenticate the user.
 *
 * @param {Object} credentials - The signup credentials.
 * @param {string} credentials.email - The username or email of the user.
 * @param {string} credentials.name - The name of the user
 * @param {string} credentials.username - The username of the user.
 * @param {string} credentials.password - The password of the user.
 * 
 * @returns {Promise<Object>} - The response data containing user info and token.
 * 
 * @throws {Error} - Throws an error if login fails or the server returns an error.
 * 
 *
 */
const signupUser = async (credentials) => {
  return await apiCall(AUTH_ROUTES.SIGNUP_API_ENDPOINT, {
    method: "POST",
    body: {
      name: credentials.name,
      email: credentials.email,
      username: credentials.username,
      password: credentials.password,
    },
    requiresAuth: false,
  });
};

export default signupUser
